import './index.scss'
$("#nav3").addClass("active");
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper('.service .swiper', {
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed:500,
    loop:true,//必须
    pagination: {
        el: ".service .swiper-pagination",
        clickable: true,
      },
});